import {
  AFINZ,
  AZULZINHA,
  BCJ,
  CRESOL,
  FISERV,
  PORTOBANK,
  SICREDI,
  STONE,
  TON,
  UNICRED,
  XP
} from '../../constants/psrs';

export const generateFiservAliancaPsrs = (response) => {
  if (!Array.isArray(response)) {
    return response || [];
  }

  const haveFiserv = response.filter((item) => item.id === FISERV);

  if (haveFiserv.length) {
    response.push({...haveFiserv[0], name: 'Azulzinha', id: AZULZINHA});
    response.push({...haveFiserv[0], name: 'Afinz', id: AFINZ});
    response.push({...haveFiserv[0], name: 'Sicredi', id: SICREDI});
    response.push({...haveFiserv[0], name: 'XP', id: XP});
    response.push({...haveFiserv[0], name: 'Cresol', id: CRESOL});
    response.push({...haveFiserv[0], name: 'BCJ', id: BCJ});
    response.push({...haveFiserv[0], name: 'PortoBank', id: PORTOBANK});
    response.push({...haveFiserv[0], name: 'Unicred', id: UNICRED});
  }

  return response;
};

export const generateStoneTonPsrs = (response) => {
  if (!Array.isArray(response)) {
    return response || [];
  }

  const haveStone = response.filter((item) => item.id === STONE);

  if (haveStone.length) {
    response.push({...haveStone[0], name: 'Ton', id: TON});
  }

  return response;
};

export const checkIdPsrAlianca = (id) => {
  switch (id) {
    case AZULZINHA:
      return FISERV;
    case AFINZ:
      return FISERV;
    case SICREDI:
      return FISERV;
    case XP:
      return FISERV;
    case CRESOL:
      return FISERV;
    case BCJ:
      return FISERV;
    case PORTOBANK:
      return FISERV;
    case UNICRED:
      return FISERV;
    case TON:
      return STONE;
    default:
      return id;
  }
};

// Backward compatibility
export const checkIdFiservAlianca = checkIdPsrAlianca;
